import { Button } from '@/components';
import { FC, useState } from 'react';
import { FaArrowUpLong } from 'react-icons/fa6';
import WithdrawFromWalletTray from './WithdrawFromWalletTray';
const WithdrawFromWalletIcon = FaArrowUpLong as React.ComponentType<any>;
const WithdrawFromWalletButton: FC = () => {
  const [isTrayOpen, setIsTrayOpen] = useState<boolean>(false);
  const openWithdrawFromWalletTray = () => {
    setIsTrayOpen(true);
  };
  return (
    <>
      <Button
        icon={<WithdrawFromWalletIcon className="text-accent" />}
        onClick={openWithdrawFromWalletTray}
        iconStyles={{ intent: 'accent' }}
      >
        Withdraw
      </Button>
      <WithdrawFromWalletTray
        isOpen={isTrayOpen}
        onClose={() => setIsTrayOpen(false)}
      />
    </>
  );
};
export default WithdrawFromWalletButton;
